import normalizeEngagements from './normalizeEngagements'

export default (entities, usersToAdd, entityId, engagementMetadata) =>
	[...entities].map((entity) => {
		if (entity.entityId === entityId) {
			const newContactsToAdd = usersToAdd.map((user) => {
				//TODO: How to complete hardcoded properties
				return {
					...user,
					isIgnored: false,
					roleId: 31,
					roleName: 'Not Applicable',
					engagements: normalizeEngagements(user.engagements, engagementMetadata),
					serviceLine: 'Not Applicable',
					serviceLineId: 7,
					contactList: {
						hasAccess: false
					},
					customColumns: [],
					tags: [],
					dashboard: []
				};
			});
			const newContacts = [...entity.contacts, ...newContactsToAdd];
			return {...entity, contacts: newContacts};
		}
		return {...entity};
	});
